// extracted by mini-css-extract-plugin
export default {"box":"index_box_KMhos","footer":"index_footer_1Miad"};